import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { UpdatePasswordMode } from '@platform-frontend/account';
import { PollingConfiguration, extendPollingConfiguration } from '@platform-frontend/platform';
import { ClickCallbackLink, TypedChanges } from '@platform-frontend/util';
import { MatomoTracker } from 'ngx-matomo-client';
import { EMPTY, Observable } from 'rxjs';
import { ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT } from '../account-ui-matomo-events';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@Component({
  selector: 'yat-check-recovery-email-ui',
  templateUrl: './check-recovery-email-ui.component.html',
  styleUrls: ['./check-recovery-email-ui.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class CheckRecoveryEmailUiComponent implements OnChanges {
  constructor(private matomoTracker: MatomoTracker) {}
  @Input()
  pollingConfiguration: PollingConfiguration;

  @Input()
  email: string | null;

  @Input()
  updatePasswordMode: UpdatePasswordMode | null;

  @Input()
  cancelPasswordUpdateText: 'backToSignIn' | 'proceed' = 'backToSignIn';

  @Output()
  resendEmail: EventEmitter<void> = new EventEmitter();

  @Output()
  cancel: EventEmitter<void> = new EventEmitter();

  readonly MATOMO_EVENT_CATEGORY_ACCOUNT = ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT;

  readonly resendEmailLink: ClickCallbackLink = {
    onClick: () => this.resendRecoveryEmail(),
    class: 'link link-secondary link-underline',
    trackingEvent: {
      category: this.MATOMO_EVENT_CATEGORY_ACCOUNT,
      action: 'Trigger_ForgotPasswordPolling',
      name: 'ResendEmail'
    },
    id: '732b1e34-e168-4a3f-a6b9-449b0be0804f'
  };
  readonly cancelLink: ClickCallbackLink = {
    onClick: () => this.cancelPasswordUpdate(),
    class: 'link link-secondary link-underline',
    trackingEvent: {
      category: this.MATOMO_EVENT_CATEGORY_ACCOUNT,
      action: 'Trigger_ForgotPasswordPolling',
      name: 'GoBackToSignIn'
    },
    id: '343be2a7-7ea1-4afe-90ba-9dae82c1acf8'
  };

  extendedConfiguration: PollingConfiguration;
  proceeding = false;

  ngOnChanges(changes: TypedChanges<CheckRecoveryEmailUiComponent>): void {
    if (changes.pollingConfiguration) {
      this.extendedConfiguration = extendPollingConfiguration(this.pollingConfiguration).withComplete(() => this.setToProceeding());
    }
  }

  private setToProceeding(): Observable<unknown> {
    this.proceeding = true;
    return EMPTY;
  }

  private resendRecoveryEmail(): void {
    this.resendEmail.next();
  }

  private cancelPasswordUpdate(): void {
    this.cancel.next();
  }
}
